// extracted by mini-css-extract-plugin
export default {"sidebar-width":"sidebar-width__jfBAu"};
    if(module.hot) {
      // 1791908882587
      var cssReload = require("../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  